import * as React from "react";
import { forwardRef } from "react";
const SvgIcItalic = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.5293 6.26465H13.5938L11.6895 17.7354H15.3232V19.5H6.5V17.7354H9.87695L11.7812 6.26465H8.70605V4.5H17.5293V6.26465Z", fill: "#241D47" }));
const ForwardRef = forwardRef(SvgIcItalic);
export default ForwardRef;
